import { render, staticRenderFns } from "./inactiveEmails.vue?vue&type=template&id=aecf99aa&"
import script from "./inactiveEmails.vue?vue&type=script&lang=js&"
export * from "./inactiveEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports